module.exports = __webpack_public_path__ + "static/media/Ted M.d4e86f24.jpg";